import ApplicationSerializer from 'lumen/serializers/application';

export default class ParityStrategyEvolutionSerializer extends ApplicationSerializer {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  modelNameFromPayloadKey() {
    return 'parity-strategy/evolution';
  }
}
